import { useTranslation } from "@redotech/redo-i18n";
import type { PurchaseChannelState } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { PurchaseChannel } from "@redotech/redo-return-warranties-common/warranties";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo, useMemo } from "react";

export const PurchaseChannelDetails = memo(function PurchaseChannelDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<PurchaseChannelState>) {
  const { t } = useTranslation();
  const channelOptions: RedoListItem<PurchaseChannel>[] = useMemo(
    () =>
      Object.values(PurchaseChannel).map((channel) => ({
        id: channel,
        value: channel,
        type: "text" as const,
        text: channel === PurchaseChannel.ONLINE ? "Shopify" : t("Retail"),
      })),
    [t],
  );

  const selectedChannel = state.channel
    ? channelOptions.find((option) => option.value === state.channel)
    : undefined;

  return (
    <RedoSingleSelectDropdownInput
      disabled={disabled}
      flexGrow
      label={t("Purchase channel")}
      options={channelOptions}
      optionSelected={({ item }) => setState({ ...state, channel: item.value })}
      placeholder={t("Select purchase channel...")}
      selectedItem={selectedChannel}
      size="xs"
    />
  );
});
